export default "__VITE_ASSET__CQwWq6Au__"